import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { PUT } from '../../../config/permissions';
import withEndpointAuthorization from '../../units/authorization/withEndPointAuthorization';
import { TOTALPOS_PAYMENT } from '../../../config/endpoints';

const PinpadPaymentButton = ({
  index,
  status,
  onStart,
  onCancel,
  onPrintVoid,
  onRestart,
  totalPosLoading,
}) => {
  if (status === 'done') {
    return (
      <Button
        type="button"
        color="danger"
        outline
        block
        onClick={() => onCancel(index)}
        disabled={totalPosLoading}
      >
        <i className="fa fa-times" /> Cancelar pago
      </Button>
    );
  }
  if (status === 'voided') {
    return (
      <>
        <Button
          type="button"
          color="secondary"
          outline
          block
          onClick={() => onPrintVoid(index)}
        >
          <i className="fa fa-print" /> Imprimir anulación
        </Button>
        <Button
          type="button"
          color="success"
          outline
          block
          disabled={totalPosLoading}
          onClick={() => onRestart(index)}
        >
          <i className="fa fa-credit-card" /> Volver a iniciar pago
        </Button>
      </>
    );
  }
  return (
    <Button
      type="button"
      color="success"
      outline
      disabled={status === 'processing' || totalPosLoading}
      onClick={() => onStart(index)}
    >
      {status === 'processing' ? (
        <>
          <i className="fa fa-spinner fa-spin" /> Procesando...
        </>
      ) : (
        <>
          <i className="fa fa-credit-card" /> Iniciar pago
        </>
      )}
    </Button>
  );
};

PinpadPaymentButton.propTypes = {
  index: PropTypes.number.isRequired,
  status: PropTypes.string,
  onStart: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPrintVoid: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired,
  totalPosLoading: PropTypes.bool,
};

PinpadPaymentButton.defaultProps = {
  status: undefined,
  totalPosLoading: false,
};

export default withEndpointAuthorization({
  url: TOTALPOS_PAYMENT,
  permissionType: PUT,
})(PinpadPaymentButton);
